var html = require("choo/html");
var { i18n } = require("../../components/base");
var { DEADLINE, OPEN } = require("../../lib/dates");

var text = i18n();

module.exports = home;

function home(state, emit) {
  emit("meta", {
    title: 'Designstipendiet Ã¢ÂÂ Information',
    description: text`SITE_DESCRIPTION`,
    "og:image": "https://www.designstipendiet.se/share-image.png",
    "og:url": "https://www.designstipendiet.se/info",
  });

  function formatDeadline(date) {
    return "31 maj 2026"; // Explicitly set to avoid timezone issues
  }

  return html`
    <body>
      <main class="Info js-scroll">
        <div class="Info-main">
          <div class="Info-content">
            <p>
              Designstipendiet tÃÂ¤cker kostnaden fÃÂ¶r utbildningen, men innebÃÂ¤r
              ocksÃÂ¥ att stipendiaten ges mÃÂ¶jlighet att anvÃÂ¤nda jurygruppen som
              bollplank under studietiden.
            </p>
            <p>
              KvÃÂ¤llsskolan pÃÂ¥ Beckmans har tre inriktningar: Form, Mode och
              Visuell Kommunikation. Utbildningen ÃÂ¤r fÃÂ¶rberedande och vilar pÃÂ¥
              konstnÃÂ¤rlig grund.
            </p>
            <p>
              KvÃÂ¤llsskolan erbjuder grundlÃÂ¤ggande orientering i ÃÂ¤mnen som
              exempelvis mÃÂ¶belformgivning, mÃÂ¶nsterkomposition, modedesign,
              fotografi, grafisk design och teckning.
            </p>
            <p>
              Familjen Robert Weils Stiftelse vill medverka till att skolan
              fortsÃÂ¤tter att vara den kreativa samlingsplats den varit sen 1939.
              En hÃÂ¶gskola dÃÂ¤r en mÃÂ¥ngfald av erfarenheter och berÃÂ¤ttelser ÃÂ¤r med
              och skapar vÃÂ¥r gemensamma framtid i en demokratisk och hÃÂ¥llbar
              riktning.
            </p>
            <p>DÃÂ¤rfÃÂ¶r har vi instiftat Designstipendiet.</p>
            <nav>
              <a href="/" class="Info-menu">Tillbaka</a>
            </nav>
          </div>
        </div>
        <div class="Info-sidebar">
          ${(DEADLINE > Date.now() && OPEN < Date.now())
            ? html`
                <ol class="Info-instructions">
                  <li class="Info-step">
                    SÃÂ¶k till KvÃÂ¤llsskolan pÃÂ¥
                    <span>
                      <a href="https://beckmans.se/studera/forberedande-utbildning-kvallsskolan/" target="_blank">beckmans.se</a>
                    </span>.
                  </li>
                  <li class="Info-step">
                    SÃÂ¶k sen <span> <a href="/ansok">Designstipendiet</a></span>.
                  </li>
                  <li class="Info-step">
                    Blir du utvald sÃÂ¥ bekostar stipendiet utbildningen. Du fÃÂ¥r
                    ocksÃÂ¥ jurygruppen som bollplank under ÃÂ¥ret.
                  </li>
                </ol>
                <div class="Info-footer">
                  Sista ansÃÂ¶kningsdag ${formatDeadline(DEADLINE)} och besked om stipendiet ges
                  kort dÃÂ¤r efter.
                </div>
              `
            : (DEADLINE < Date.now() ? html`
                <ol class="Info-instructions">
                  <li>ÃÂrets ansÃÂ¶kning ÃÂ¤r nu stÃÂ¤ngd.</li>
                </ol>
              ` : html`<ol class="Info-instructions"><li>AnsÃÂ¶kan ÃÂ¶ppnar i slutet av januari 2026</li></ol>`)}
        </div>
      </main>
    </body>
  `;
}
